import { IconProps } from './IconProps';

export function ArticleIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_10627_28914)">
                <path
                    d="M9.5 10C9.5 10.1326 9.44732 10.2598 9.35355 10.3536C9.25979 10.4473 9.13261 10.5 9 10.5H4C3.86739 10.5 3.74021 10.4473 3.64645 10.3536C3.55268 10.2598 3.5 10.1326 3.5 10V5C3.5 4.86739 3.55268 4.74021 3.64645 4.64645C3.74021 4.55268 3.86739 4.5 4 4.5H9C9.13261 4.5 9.25979 4.55268 9.35355 4.64645C9.44732 4.74021 9.5 4.86739 9.5 5V10Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M11.5 4.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M11.5 7.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M11.5 10.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M3.5 13.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M3.5 16.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M3.5 19.5H14.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M20.5 23.5H3.5C2.70435 23.5 1.94129 23.1839 1.37868 22.6213C0.81607 22.0587 0.5 21.2956 0.5 20.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H16.5C16.7652 0.5 17.0196 0.605357 17.2071 0.792893C17.3946 0.98043 17.5 1.23478 17.5 1.5V20.5C17.5 21.2956 17.8161 22.0587 18.3787 22.6213C18.9413 23.1839 19.7044 23.5 20.5 23.5ZM20.5 23.5C21.2956 23.5 22.0587 23.1839 22.6213 22.6213C23.1839 22.0587 23.5 21.2956 23.5 20.5V3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
                <path
                    d="M20.5 3.5V21"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#66182A"
                />
            </g>
            <defs>
                <clipPath id="clip0_10627_28914">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
